export const initalFormValues = {
  capacityOfApplicant: '',
  applicantSuitability: {
    academicAchievements: '',
    knowledgeOfArea: '',
    capacityToResearch: '',
    englishProficiency: '',
    chineseProficiency: '',
    analyticalAbilities: '',
    capacityOfOriginalThinking: '',
    motivation: '',
  },
  proposalComment: '',
  commentsToPolyU: '',
  overallRecommendation: '',
};

export enum REFEREE_FORM_STATUS {
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  EXPIRED = 'EXPIRED',
}
